
export const UTM_CONTENT_CODE = {
  viewMyPlan: 'view-my-plan',
  reviewYourSubscription: 'review-your-subscription',
  getStarted: 'get-started',
  downloadZoom: 'download-zoom',
  setUpZoomPhone: 'set-up-zoom-phone',
  setUpZoomWorkplacePro: 'set-up-zoom-workplace-pro',
  setUpZoomWorkplaceBiz: 'set-up-zoom-workplace-biz',
  setUpZoomWorkplaceProPlus: 'set-up-zoom-workplace-pro-plus',
  setUpZoomWorkplaceBizPlus: 'set-up-zoom-workplace-biz-plus',
  setUpYourZoomAccount: 'set-up-your-zoom-account',
  unassignLicense: 'unassign-license',
  unassignUsers: 'unassign-users',
  assignLicenseToUsers: 'assign-license-to-users',
  unassignRooms: 'unassign-rooms',
  viewMyPlanStatus: 'view-my-plan-status',
  viewPaymentHistory: 'view-payment-history',
  printInvoice: 'print-invoice',
  payNow: 'pay-now'
}

export const getEmailCTAsTrackingUrl = (baseUrl, options, connectors = '?') => {
  const {utmMedium = 'email', utmSource = 'op', utmCampaign = 'order-confirmation', utmTerm = 'ecomm', utmContent = '' } = options;
  return `${baseUrl}${connectors}utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}&utm_content=${utmContent}`;
}
